import axios from "../axiosInterceptor/AdminAxiosInterceptor"
axios.defaults.withCredentials = true;

export const googleAuth = (googleToken) =>
  axios.post("auth/google/", { token: googleToken });

export const get_downloads = () => axios.get("/get-downloads-app/")

export const fetch_coustomers = () => axios.get("admin-get-all-customers/");

export const fetch_coustomers_optimized = (page = 1, search = "", pageSize = 100) =>
  axios.get("admin-get-all-customers-optimized/", {
    params: {
      page,
      search,
      page_size: pageSize,
    },
  });

export const create_customer = (data) => axios.post("admin-create-customer/", data);

export const update_customer = (id, data) => axios.put(`admin-update-customers/${id}/`, data);

export const update_downloads = (downloadId, play_store, app_store) =>
  axios.put(`update-downloads-app/${downloadId}/`, {
    play_store,
    app_store,
  });
export const fetch_family_members_by_customer = (customerId) =>
  axios.get(
    `admin-get-family-members-by-customer-id/${customerId}/`
  );

export const fetch_all_bmi = () =>
  axios.get("get-all-bmi/");

export const create_bmi = (data) =>
  axios.post("admin-create-bmi/", data);

export const update_bmi = (id, data) =>
  axios.put(`update-bmi/${id}/`, data);

export const fetch_all_cities = () =>
  axios.get("admin-get-all-city/");

export const get_cities_by_state = (stateId) => axios.get(`admin-get-cities-by-state/${stateId}`)

export const create_city = (data) =>
  axios.post("admin-create-city/", data);

export const update_city = (data) =>
  axios.put(`admin-create-city/`, data);

export const fetch_all_containers = () =>
  axios.get("admin-get-all-containers/");

export const create_container = (data) =>
  axios.post("admin-create-container/", data);

export const update_container = (id, data) =>
  axios.put(`admin-update-container/${id}/`, data);

export const fetch_all_countries = () =>
  axios.get("admin-get-all-country/");

export const create_country = (data) =>
  axios.post("admin-create-country/", data);

export const update_country = (data) =>
  axios.put(`admin-create-country/`, data);

export const fetch_all_coupons = () =>
  axios.get("admin-get-all-coupons/");

export const create_coupon = (data) =>
  axios.post("admin-create-coupon/", data);

export const update_coupon = (couponId, data) =>
  axios.put(`admin-edit-coupon/${couponId}/`, data);

export const toggle_coupon_status = (couponId) =>
  axios.put(`admin-toggle-coupon-status/${couponId}/`);

export const create_customer_location = (data) =>
  axios.post("admin-customers-create-location/", data);

export const fetch_customer_details = (customerId) =>
  axios.get(`admin-customer0details-${customerId}/`);

export const admin_create_family_member = (data) =>
  axios.post("admin-create-family-member-of-customer/", data);

export const fetch_all_patients = () =>
  axios.get("admin-get-all-patients/");

export const fetch_all_family_member_types = () =>
  axios.get("admin-get-all-family-member-type/");

export const create_family_member_type = (data) =>
  axios.post("admin-create-family-member-type/", data);

export const update_family_member_type = (data) =>
  axios.put(`admin-create-family-member-type/`, data);

export const fetch_health_conditions = () =>
  axios.get("admin-get-health-conditions/");

export const create_health_condition = (data) =>
  axios.post("admin-manage-health-condition/", data);

export const update_health_condition = (data) =>
  axios.put(`admin-manage-health-condition/`, data);

export const fetch_all_labs = () =>
  axios.get("admin-get-all-labs/");

export const create_lab_coordinates = (data) =>
  axios.post("admin-create-coordinates-of-lab/", data);

export const update_lab_coordinates = (data) =>
  axios.post("admin-update-coordinates-of-lab/", data);

export const admin_create_lab = (data) =>
  axios.post("admin-create-lab/", data);

export const admin_update_lab = (id, data) =>
  axios.put(`admin-lab-update/${id}/`, data);

export const create_lab_lims = (data) =>
  axios.post("admin-create-lab-lims/", data);

export const update_lab_lims = (data) =>
  axios.put("admin-update-lab-lims/", data);

export const create_lab_user = (data) =>
  axios.post("admin-create-lab-user/", data);

export const update_lab_user = (data) =>
  axios.put("admin-update-lab-user/", data);

export const create_lab_address = (data) =>
  axios.post("admin-create-lab-address/", data);

export const update_lab_address = (data) =>
  axios.put("update-lab-address/", data);

export const fetch_all_languages = () =>
  axios.get("admin-get-all-languages/");

export const create_language = (data) =>
  axios.post("admin-create-language/", data);

export const update_language = (data) =>
  axios.put("admin-create-language/", data);

export const get_customers_with_multiple_orders = () =>
  axios.get("customers/multiple-orders/");

export const get_total_b2c_price = () =>
  axios.get("orders/total-price/");

export const get_total_discount = () =>
  axios.get("orders/total-discount/");

export const get_monthly_orders_count = (month, year) =>
  axios.get(`orders/monthly-count/${month}/${year}`);

export const fetchData = async (url) => {
  const response = await axios.get(url);
  return response.data;
};

export const download_active_customers = (customerIds) =>
  axios.post("download-active-customers/", { ids: customerIds }, { responseType: "blob" });

export const createOrderItem = (payload) =>
  axios.post("admin-create-order-item/", payload);

export const createOrderItemNew = (payload) =>
  axios.post("admin-create-order-item-new/", payload);

export const getOrderItemsByCustomer = (customerId) =>
  axios.get(`admin-get-order-items/${customerId}/`);

export const getCustomerDetails = (customerId) =>
  axios.get(`admin-customer0details-${customerId}/`);

export const getOrderById = (orderId) =>
  axios.get(`edit-order/${orderId}/`);

export const cancelOrderById = (orderId, payload) =>
  axios.post(`admin-cancel-order/${orderId}/`, payload);

export const updateOrderById = (orderId, payload) =>
  axios.put(`admin-update-order/${orderId}/`, payload);

export const createAdminOrder = (payload) =>
  axios.post("admin-create-order/", payload);

// export const addReportToPatient = (formData) =>
//   axios.post("add-report-to-patient/", formData, {
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//   });

// export const fetchReport = (reportUrl) =>
//   axios.get(reportUrl);

// export const fetchTransactions = (transactionsUrl) =>
//   axios.get(transactionsUrl);

export const addReportToPatient = (formData) =>
  axios.post("add-report-to-patient/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const fetchReport = (reportUrl) =>
  axios.get(reportUrl, {
    responseType: "blob", // 
  });

export const fetchTransactions = (transactionsUrl) =>
  axios.get(transactionsUrl, {
    responseType: "blob",
    withCredentials: true,
  });

export const fetchAdminOrders = () =>
  axios.get("admin-get-all-orders/");

export const fetchAdminPackages = () =>
  axios.get("admin-get-all-packages/");


export const createBulkPackages = (extractedData, lab) =>
  axios.post("admin-create-bulk-packages/", {
    values: extractedData,
    lab_id: lab,
  });

export const createPackage = (payload) => {
  return axios.post("admin-create-package/", payload);
};

export const updatePackage = (id, payload) => {
  return axios.put(`admin-update-package/${id}/`, payload);
};

export const getAllPincodes = () => {
  return axios.get("admin-get-all-pincodes/");
};

export const create_pincode = (data) =>
  axios.post("admin-create-pincode/", data);

export const update_pincode = (data) =>
  axios.put("admin-create-pincode/", data);

export const create_poc = (data) =>
  axios.post("create-poc/", data);

export const get_pouches = () =>
  axios.get("admin-get-pouches/");

export const update_pouch = (id, data) =>
  axios.put(`admin-update-pouch/${id}/`, data);

export const create_pouch = (data) =>
  axios.post("admin-create-pouch/", data);

export const get_billing_report = (
  startDate,
  endDate,
  page = 1,
  pageSize = 20
) => {
  let queryParams = [];
  if (startDate && endDate) {
    queryParams.push(`startDate=${startDate}`);
    queryParams.push(`endDate=${endDate}`);
  }
  queryParams.push(`page=${page}`);
  queryParams.push(`page_size=${pageSize}`);
  const queryString = queryParams.length
    ? `?${queryParams.join("&")}`
    : "";
  return axios.get(`billing-report${queryString}`);
};

export const get_billing_report_export = (startDate, endDate) => {
  let queryParams = [];
  if (startDate && endDate) {
    queryParams.push(`startDate=${startDate}`);
    queryParams.push(`endDate=${endDate}`);
  }
  const queryString = queryParams.length
    ? `?${queryParams.join("&")}`
    : "";
  return axios.get(`billing-report-export${queryString}`);
};

export const get_order_not_accept_report = (startDate, endDate) => {
  const queryParams = startDate && endDate ? `?startDate=${startDate}&endDate=${endDate}` : "";
  return axios.get(`order-not-accepted-report${queryParams}`);
};

export const patientwise_report = (endDate) => {
  const queryParams = endDate ? `?endDate=${endDate}` : "";
  return axios.get(`billing-report${queryParams}`);
};

export const get_test_report = (
  startDate,
  endDate,
  page = 1,
  pageSize = 10
) => {
  const params = new URLSearchParams();

  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);

  params.append("page", page);
  params.append("page_size", pageSize);

  return axios.get(`test-report?${params.toString()}`);
};

export const get_test_report_all = (startDate, endDate) => {
  const params = new URLSearchParams();

  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);

  return axios.get(`test-report-export?${params.toString()}`);
};



export const get_tat_report = (startDate, endDate) => {
  const queryParams = startDate && endDate ? `?startDate=${startDate}&endDate=${endDate}` : "";
  return axios.get(`tat-report${queryParams}`);
};

export const get_tat_failure_report = (startDate, endDate) => {
  const queryParams = startDate && endDate ? `?startDate=${startDate}&endDate=${endDate}` : "";
  return axios.get(`tat-failure-report${queryParams}`);
};

export const get_test_report_with_coupon_applied = (startDate, endDate) => {
  const queryParams = startDate && endDate ? `?startDate=${startDate}&endDate=${endDate}` : "";
  return axios.get(`/api/test-report-with-coupon-applied${queryParams}`);
};

export const get_all_states = () => axios.get("admin-get-all-state/");

export const get_state_by_country = (countryId) => axios.get(`admin-get-state-by-country/${countryId}`)

export const create_state = (data) =>
  axios.post("admin-create-state/", data);

export const update_state = (data) =>
  axios.put("admin-create-state/", data);

export const fetch_all_tats = () =>
  axios.get("admin-get-all-tats/");

export const update_tat = (id, payload) =>
  axios.put(`admin-update-tat/${id}/`, payload);

export const create_tat = (payload) =>
  axios.post(`admin-create-tat/`, payload);

export const get_all_tests = () =>
  axios.get(`admin-get-all-tests/`);

export const get_paginated_tests = (
  search = "",
  page = 1,
  pageSize = 10,
  department = null
) => {
  let query = `?page=${page}&page_size=${pageSize}`;

  if (search) query += `&search=${search}`;
  if (department) query += `&test_department=${department}`;

  return axios.get(`admin-get-all-tests-paginated/${query}`);
};

export const get_all_tests_labs = (labId) =>
  axios.get(`admin-get-all-tests-labs/?lab_id=${labId}`);

export const create_lab_test = (data) =>
  axios.post("admin-lab-tests/", data);

export const update_lab_test = (id, data) =>
  axios.put(`admin-lab-tests/${id}/`, data);

export const create_bulk_tests = (values, lab_id) =>
  axios.post("admin-create-bulk-tests/", {
    values,
    lab_id,
  });

export const create_test_category = (data) =>
  axios.post("admin-create-test-category/", data);

export const update_test_category = (id, data) =>
  axios.put(`admin-update-test-category/${id}/`, data);

export const get_all_test_categories = () =>
  axios.get("admin-get-all-test-categories/");

export const get_all_test_requirements = () =>
  axios.get("admin-get-all-test-requirements/");

export const update_test_requirement = (id, data) =>
  axios.put(`update-test-requirement/${id}/`, data);

export const create_test_requirement = (data) =>
  axios.post("admin-create-test-requirement/", data);

export const admin_get_all_tags = () =>
  axios.get("admin-get-all-tags/");

export const create_tag = (data) =>
  axios.post("admin-create-tag/", data);

export const update_tag = (id, data) =>
  axios.put(`admin-update-tag/${id}/`, data);

export const get_all_executives = () =>
  axios.get("admin-get-all-executive/");

export const assign_lab_to_we = (payload) =>
  axios.post("assign-lab-to-we/", payload);

export const update_assign_lab_to_we = (payload) =>
  axios.post("update-assign-lab-to-we/", payload);

export const createExecutive = (payload) =>
  axios.post("admin-create-executive/", payload);

export const updateExecutive = (payload) =>
  axios.post("update-wellness-executive/", payload);

export const toggleExecutiveStatus = (id, status) =>
  axios.post("disable-wellness-executives/", {
    id,
    status,
  });

export const getAllExecutives = () =>
  axios.get("admin-get-all-executive/");

export const getOrderSlots = () => axios.get("order-slots/");

export const createWorkingHours = (data) =>
  axios.post("admin-working-hours/", data);

export const updateWorkingHours = (id, data) =>
  axios.put(`admin-working-hours/${id}/`, data);

// export const secureImageGet = (path) => axios.get(path);
export const secureImageGet = (path) => axios.get(path, { responseType: "blob" });

export const wellnessAddCertificate = (formBody) => axios.put('add-certificate/', formBody)

export const getWellnessExecutiveReport = (params) => axios.get("wellness-executive-report/", { params });

export const createB2BClient = (formBody) => axios.post('b2b-clients/', formBody)

export const updateB2BClient = (id, formBody) => axios.patch(`b2b-clients/${id}/`, formBody)

export const getAllB2BClients = () => axios.get('b2b-clients/')

export const assignTestB2B = (values) => axios.post("assign-b2b-test/", values)

export const create_bulk_b2b_tests = (values, b2b_client) => axios.post("bulk-assign-b2b-test/", { "b2b_client": b2b_client, "tests": values })

export const create_bulk_b2b_packages = (values, b2b_client) => axios.post("bulk-assign-b2b-package/", { "b2b_client": b2b_client, "packages": values })

export const assignPackageB2B = (values) => axios.post("assign-b2b-package/", values)

export const getAllClientServices = ({ page = 1, search = "" }) =>
  axios.get("b2b-client/services/", {
    params: {
      page,
      page_size: 10,
      search,
    },
  });

export const getAllQr = () => axios.get('get-all-qr/')

export const createQr = (formBody) => axios.post('create-qr/', formBody)

export const getQrLocationById = (id) => axios.get(`qr-location/${id}`)

export const getQrLocationPublicById = (id) => axios.get(`qr-location-public/${id}`)

export const getQRdetail = (locationId, start_date = "", end_date = "") => {

  let url = `qr-details/${locationId}/?`;
  if (start_date) url += `start_date=${start_date}&`;
  if (end_date) url += `end_date=${end_date}&`;
  url = url.slice(0, -1);

  return axios.get(url);
};

export const getDelayTime = () => axios.get(`delay-time/`)

export const SetDelayTime = (formBody) => axios.post(`delay-time/`, formBody)

export const create_b2b_client_location = (formBody) => axios.post("b2b-client-locations/", formBody)

export const update_b2b_client_location = (id, formBody) => axios.put(`b2b-customers-edit-location/${id}/`, formBody)

export const getOrders = (page = 1, pageSize = 10, search = "", status = "") => {
  return axios.get(`admin-get-all-orders-optimized/`, {
    params: {
      page: page,
      page_size: pageSize,
      ...(search && { search: search }),
      ...(status && { status: status }),
    }
  });
};


export const edit_order = (id) => axios.get(`edit-order/${id}/`)

export const cancel_order = (id, formbody) => axios.post(`admin-cancel-order/${id}/`, formbody)

export const get_parameters = (search = "", page = 1, page_size = 10) => {
  let url = `/parameters/?page=${page}&page_size=${page_size}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  return axios.get(url);
};

export const create_parameter = (data) => axios.post("/parameters/", data);

export const update_parameter = (id, data) => axios.patch(`/parameters/${id}/`, data);

export const delete_parameter = (id) => axios.delete(`/parameters/${id}/`);

export const link_test_to_parameter = (test_id, parameter_id) => {
  return axios.post("/test-parameters/", {
    test_id,
    parameter_id,
  });
};

export const get_test_parameters = (search = "", page = 1, pageSize = 10) => {
  return axios.get("/test-parameters/", {
    params: { search, page, page_size: pageSize },
  });
};

export const update_test_parameter = (id, data) => {
  return axios.patch(`/test-parameters/${id}/`, data);
};

export const create_test_parameter = (data) => {
  return axios.post("/test-parameters/", data);
};

export const delete_test_parameter = (id) => {
  return axios.delete(`/test-parameters/${id}/`);
};

export const get_test_linked_parameters = (test_id) => {
  return axios.get(`/test-parameters/`, { params: { search: "", test_id } });
};

export const get_all_active_parameters = () => {
  return axios.get("/admin-all-parameters/");
};

export const fetch_test_departments = () =>
  axios.get("test-departments/");

export const create_test_department = (data) =>
  axios.post("test-departments/", data);

export const update_test_department = (id, data) =>
  axios.put(`test-departments/${id}/`, data);

export const getSystemSettings = () =>
  axios.get("system-settings/");

export const updateSystemSetting = (id, data) =>
  axios.patch(`system-settings/${id}/`, data);

export const get_disease_report = (data) =>
  axios.post("disease-report/", data);

export const get_unique_test_names = () =>
  axios.get("unique-testnames/");

export const fetch_camp_coordinates = () =>
  axios.get("camp-coordinates/");

export const create_camp_coordinates = (data) =>
  axios.post("camp-coordinates-create/", data);

export const create_camp_location = (data) =>
  axios.post("camp-location-create/", data);

export const update_camp_coordinates = (id, data) =>
  axios.patch(`camp-coordinates/${id}/update/`, data);

export const regenerateInvoice = (orderId) =>
  axios.post(`regenerate-invoice/`, { order_id: orderId });